import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const CraftMasterclasses = () => <EventCategoryPage config={EVENT_CATEGORIES['craft-masterclasses']} data-id="element-9157" data-mp="kz7frckenbfg" />;
export default CraftMasterclasses;